import Global from "../config/config.json";
import httpService from "../config/httpService";
const profileAPI = {
  async setActiveGame(jwt,data) {
    let res = [];
    await httpService
      .post(`${Global.Nameh}profile/set_active_game`,{ gid:data}, {
        headers: { Authorization: `${jwt.token_type} ${jwt.access_token}` },
      })
      .then((json) => {
        if (json.status == 200) {
          res = json.data;
        }
      });
    return res;
  },
  async updateProfile(data, jwt) {
    let res = [];
    await httpService
      .post(`${Global.Nameh}profile/update`, data, {
        headers: { Authorization: `${jwt.token_type} ${jwt.access_token}` },
      })
      .then((json) => {
        console.log("login", json);
        switch (json.status) {
          case 201:
          case 200:
            res = json.data;
            break;
        }
      });
    return res;
  },
  async games(jwt) {
    let res = [];
    await httpService
      .get(`${Global.Nameh}profile/games`, {
        headers: { Authorization: `${jwt.token_type} ${jwt.access_token}` },
      })
      .then((json) => {
        switch (json.status) {
          case 200:
            res = json.data;
            break;
        }
      });
    return res;
  },
  async messages(jwt) {
    let res = [];
    await httpService
      .get(`${Global.Nameh}profile/messages`, {
        headers: { Authorization: `${jwt.token_type} ${jwt.access_token}` },
      })
      .then((json) => {
        switch (json.status) {
          case 200:
            res = json.data;
            break;
        }
      });
    return res;
  },
};
export default profileAPI;
